/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import Video, { type VideoProps } from 'components/Video/Video';
import './Interview.scss';

const DEFAULT_VIDEO: VideoProps = {};

interface InterviewProps {
  layout?: 'left' | 'right';
  category?: string;
  heading?: string;
  intro?: string;
  video?: VideoProps;
}

/**
 * This is the Interview component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 */
function Interview({
  layout = 'left',
  category,
  heading = '',
  intro = '',
  video = DEFAULT_VIDEO,
}: InterviewProps) {
  function renderText() {
    return (
      <div className="text">
        <small className="stamp" stagger-text="true">
          {category}
        </small>
        <h2 dangerouslySetInnerHTML={{ __html: heading }} stagger-text="true" />
        <p dangerouslySetInnerHTML={{ __html: intro }} appear="true" />
      </div>
    );
  }

  if (layout === 'right') {
    return (
      <div className="block interview layout-right">
        {renderText()}
        <div className="video-container" appear="true">
          <Video {...video} />
        </div>
      </div>
    );
  }

  return (
    <div className="block interview layout-left">
      <div className="video-container" appear="true">
        <Video {...video} />
      </div>
      {renderText()}
    </div>
  );
}

export default Interview;
